import { SidebarModalListItem } from '@domain-group/suit-theme'

import useProviderPackageItem from '@hooks/useProviderPackageItem'

import { confirmDelete } from '@functions/entity'

import { ActionResult } from '@redux/modules/module'
import { ProviderPackageItemModel } from '@models/types'

type Callbacks = {
  toggleId: (responseObject: { response: ActionResult<ProviderPackageItemModel> }) => void,
}

type ProviderPackageProductListItemProps = {
  callbacks: Callbacks,
  providerPackageItemId: number,
}

const ProviderPackageProductListItem = (props: ProviderPackageProductListItemProps) => {
  const {
    callbacks: { toggleId },
    providerPackageItemId,
  } = props

  const {
    callbacks: { deleteProviderPackageItem: deleteFn },
    providerPriceList,
    providerPackageItem: {
      options_string, price, quantity, title,
    },
  } = useProviderPackageItem({ id: providerPackageItemId })

  const confirmDeletePayload = {
    callbacks: {
      deleteFn,
      afterAction: toggleId,
    },
    strings: {
      confirmString: 'Are you sure?',
      entityName: 'Product',
    },
  }

  return (
    <SidebarModalListItem
      secondaryText={`$${price} ${providerPriceList?.title}`}
      title={`${quantity} x ${title}${options_string}`}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <SidebarModalListItem.Actions>
        {/*
         // @ts-expect-error TS2339 */}
        <SidebarModalListItem.Icon
          marginRight="medium"
          onClick={() => confirmDelete(confirmDeletePayload)}
          type="delete"
        />
        {/*
       // @ts-expect-error TS2339 */}
      </SidebarModalListItem.Actions>
    </SidebarModalListItem>
  )
}

export default ProviderPackageProductListItem
